/* ============================================================
   Biwa Wave — inertia scroll
   Lenis-style smoothing for mouse-wheel scrolling on desktop.
   The page glides instead of stepping. Native behavior is kept for
   touch devices, keyboards, scrollbars, inner scrollers (drawers,
   modals), the theme editor, and reduced-motion users.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var target = window.scrollY;
  var current = target;
  var active = false;
  var EASE = 0.105;

  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  function insideScroller(node) {
    var el = node;
    while (el && el !== document.body && el !== document.documentElement) {
      if (el.nodeType === 1) {
        var s = window.getComputedStyle(el);
        if ((s.overflowY === 'auto' || s.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1) {
          return true;
        }
      }
      el = el.parentElement;
    }
    return false;
  }

  function step() {
    current += (target - current) * EASE;
    if (Math.abs(target - current) < 0.5) {
      current = target;
      window.scrollTo(0, Math.round(current));
      active = false;
      return;
    }
    window.scrollTo(0, Math.round(current));
    requestAnimationFrame(step);
  }

  window.addEventListener('wheel', function (e) {
    if (e.ctrlKey || e.metaKey) return;            /* pinch zoom */
    if (e.defaultPrevented) return;
    if (insideScroller(e.target)) return;          /* drawers, modals, selects */

    var dy = e.deltaY;
    if (e.deltaMode === 1) dy *= 16;               /* line mode → px */
    else if (e.deltaMode === 2) dy *= window.innerHeight;

    e.preventDefault();
    if (!active) { current = window.scrollY; }
    target = Math.max(0, Math.min(maxScroll(), target + dy));
    if (!active) { active = true; requestAnimationFrame(step); }
  }, { passive: false });

  /* keep in sync when the user scrolls by other means */
  window.addEventListener('scroll', function () {
    if (!active) { target = current = window.scrollY; }
  }, { passive: true });
})();
